import React from "react"
import "./SpaceLinks.scss"

import googleMeetIcon from "./google-meet.svg"
import externalLinkIcon from "./external-link.svg"
import CopyableLink from "../CopyableLink/CopyableLink"
import classNames from "classnames"

function SpaceLinks({ hideTitle = true, align = "center", space = {} }) {
  return (
    <div className="SpaceLinks">
      {hideTitle ? "" : <h4>Links</h4>}
      <div className={`SpaceLinks__links SpaceLinks__links--${align}`}>
        <CopyableLink
          href={`${location.origin}/shared/${space.share_token}`}
          title="Guest link"
          target="_blank"
          rel="noreferrer"
          className="SpaceLinks__link"
        >
          <img src={externalLinkIcon} />
        </CopyableLink>
        {space.google_meet_url && (
          <CopyableLink
            href={space.google_meet_url}
            title="Go to meeting"
            target="_blank"
            rel="noreferrer"
            className="SpaceLinks__link"
          >
            <img src={googleMeetIcon} />
            <div
              className={classNames("SpaceLinks__counter", {
                "SpaceLinks__counter--visible":
                  Boolean(space.google_meet_participant_count) > 0,
              })}
            >
              {space.google_meet_participant_count}
            </div>
          </CopyableLink>
        )}
      </div>
    </div>
  )
}

export default SpaceLinks
